import "../../_namespaces.js";
import "../../_generated_templates.js";
import "./choice.js";

window.AssessmentViewer ??= {};
window.AssessmentViewer.Views ??= {};

AssessmentViewer.Views.ResponseSelectMultipleChoice = class ResponseSelectMultipleChoice extends (
  AssessmentViewer.Views.ResponseChoice
) {};
AssessmentViewer.Views.ResponseSelectMultipleChoice.prototype.className = "response-select-multiple-choice";
AssessmentViewer.Views.ResponseSelectMultipleChoice.prototype.template = _.template(
  AssessmentViewer.Templates.Response.select_multiple_choice,
);
